<form [formGroup]="syncForm">
  <label [for]="'standardconfig'" style="margin:0;">Standard Config</label>
  <div class="input-group md-3">
    <kendo-combobox #standardconfig class="form-control mb-2 mb-sm-0" [data]="dStandardConfiguration" [textField]="'Name'" [valueField]="'StandardConfigurationId'" [disabled]="disabled()"
      [placeholder]="'Select Stnd Config...'" [disabled]="disableAllEdits" [value]="valueStandardConfiguration" [clearButton]="false" (valueChange)="handleStandardConfigurationSelection($event)">
    </kendo-combobox>
  </div>
</form>

@if (this.ShowConfirmDialog) {
<kendo-dialog title="Change Standard Config" (close)="this.ShowConfirmDialog = false; cancelStandardConfigChange();">
  <p style="margin: 30px; text-align: center;">This action will cause the draft estimate item(s) to be refreshed. Would you like to proceed?
  </p>
  <kendo-dialog-actions>
    <button type="button" kendoButton (click)="processStandardConfigChange(true)" themeColor="primary">Yes</button>
    <button type="button" kendoButton (click)="cancelStandardConfigChange()">No</button>
  </kendo-dialog-actions>
</kendo-dialog>
}